<dgx-modal
  class="guts-p-t-0"
  [canCancel]="false"
  [isHeaderBorderless]="false"
  [isPendingWithOverlay]="true"
  [useDefaultForm]="false"
  [useDefaultSubmitButton]="false"
  [isFooterless]="true"
  trapFocus
>
  <ng-container class="modal-header" *ngIf="!isEditing">
    {{ modalTitle }}
  </ng-container>

  <ng-container class="modal-body">
    <form
      role="form"
      [formGroup]="form"
      class="form-wrap guts-p-full-1"
      (ngSubmit)="onSubmit()"
    >
      <div [class.input-success-kickstart]="shouldShowResults">
        <div class="input-success-wrap">
          <df-form-root
            [form]="form"
            [model]="model"
            [fields]="fields"
            *ngIf="!isLoading"
          >
          </df-form-root>
        </div>
        <!--Submit button and submission results-->
        <dgx-global-add-results
          *ngIf="initialViewModel.entryUrl"
          [buttonText]="i18n.MediaFormCtrl_SaveVideo"
          [isCompleting]="true"
          [isNewbUser]="isNewbUser"
          [submissionStatus]="submissionStatus"
          [creationFeedback]="creationFeedback"
          [classifier]="'learning'"
          (dismissWithNavigation)="onNavigateToCollection($event)"
        ></dgx-global-add-results>
      </div>
    </form>

    <df-spinner *ngIf="isLoading"></df-spinner>
  </ng-container>
</dgx-modal>

<ng-template #visibility let-formControl="formControl" let-params="params">
  <dgx-orgs-internal-content-visibility
    *ngIf="authUser.canRestrictContent; else groupVisibility"
    [hideTitle]="true"
    [orgId]="organization.organizationId"
    [visibleToOrg]="visibleToOrg"
    (setVisibilityValues)="handleSetVisibilityValues($event)"
  ></dgx-orgs-internal-content-visibility>
  <ng-template #groupVisibility>
    <dgx-group-visibility
      [groupIds]="selectedGroupIds"
      [groupNames]="selectedGroupNames"
      [includeUsersGroups]="true"
      [customTitle]="i18n.dgOrgInternalContentForm_GroupsTitle"
      [selectCallback]="handleGroupsAdd"
      [deselectCallback]="handleGroupsRemove"
      [customGroupTooltip]="i18n.dgOrgInternalContentForm_GroupsToolTip"
    ></dgx-group-visibility>
  </ng-template>
</ng-template>

<ng-template
  #skillsView
  let-formControl="formControl"
  let-params="params"
  dfSkill
>
  <dgx-tags-edit
    #tagsEditor
    class="form-wrap guts-p-t-1-quart guts-p-b-1"
    [hideTopTags]="true"
    [tags]="formControl.value | pascalCase"
    [completing]="isCompleting"
    (tagsChange)="handleTagsChange(formControl, $event)"
  ></dgx-tags-edit>
</ng-template>
